/* eslint-disable camelcase */
import DataGridComponent from '@components/datagrid/DataGridComponent';
import BasicDatePicker from '@components/form/date-picker/BasicDatePicker';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {ContainerGridStyle} from '@modules/home/main/modules-menu/module-search-filter/ModuleSearchFilterStyle';
import {
  Grid,
  Typography,
  Box,
  Card,
  useTheme,
  InputAdornment,
  CircularProgress
} from '@mui/material';
import MuiPagination from '@mui/material/Pagination';
import FormConstants from '@shared/constants/FormConstants';
import {
  createAuditLog,
  getPageData
} from '@shared/services/service-handlers/PrivateService';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import {useSnackbar} from 'notistack';
import React, {ReactElement, useEffect, useState, useCallback} from 'react';
import {Controller, useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router-dom';
import {BASE_RECORD_ID, LOCAL_SEARCH} from 'src/routes/BaseRoute';
import AuthUtils from 'src/utils/AuthUtils';
import EncryptUtils from 'src/utils/EncryptUtils';
import {
  NoDataGridComponentDiv,
  DataGridComponentDiv,
  InputFieldGrid
} from './vitalsStyle';
import {
  gridPageSelector,
  gridPageSizeSelector,
  gridRowCountSelector,
  useGridApiContext,
  useGridSelector,
  GridToolbarContainer,
  GridToolbarExport,
  GridCellParams,
  GridToolbarQuickFilter,
  GridPagination
} from '@mui/x-data-grid-premium';
import ActionModalDialog from '@components/dialog/action-dialog/ActionModalDialog';
import ComponentLoader from '@components/loaders/component-loader/ComponentLoader';
import CardComponent from '@components/card/CardComponent';
import CollapsibleTable from '../../modules/home/main/sub-modules-menu/collapsible-table/CollapsibleTable';
import {ExpandLessOutlined, ExpandMoreOutlined} from '@mui/icons-material';
import {RowsCountDivStyle} from '../../modules/home/main/sub-modules-menu/collapsible-table/CollapsibleTableStyle';
import {environment} from '@shared/config/environment';
import {useAppContext} from '@context/AppContext';
import moment from 'moment';
import {LoadingButton} from '@mui/lab';
import {CircularProgressDiv} from '@modules/public/main/login/LoginStyles';
import {PulseLoader} from 'react-spinners';
import {RHFAutocomplete} from 'src/minimal-components/hook-form';
import FormProvider from 'src/minimal-components/hook-form/form-provider';
import EmptyContent from '@components/empty-content/empty-content';
import {useModuleContext} from '@context/ModuleContext';
import dayjs from 'dayjs';

interface VitalsComponentProps {
  sectionUIData: any;
  sectionRowsData: any;
  changeLegacySystem?: string;
  onLegacySystemChange?: (value: string) => void;
  ParentLegacyValue?: string;
  rowId?: any;
}

const VitalsComponent = (props: VitalsComponentProps): React.ReactElement => {
  const theme = useTheme();
  const {
    appState: {applicationName}
  } = useAppContext();
  const {
    moduleState: {isBH, isBHReason}
  } = useModuleContext();
  const {sectionUIData, ParentLegacyValue, rowId} = props;
  const params: any = useParams();
  const record_id = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const [selectName, setSelectName] = React.useState({
    legacy_system: '',
    flowsheet_group: '',
    FlowsheetGroup: '',
    legacy_group: '',
    LegacyAppGroup: '',
    user_id: record_id,
    ID: record_id,
    start_date: '',
    stop_date: ''
  });

  const CustomToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarQuickFilter />
      <Box sx={{flexGrow: 1}} />

      {sectionUIData.is_export_data_needed ? (
        <GridToolbarExport printOptions={{disableToolbarButton: true}} />
      ) : null}
    </GridToolbarContainer>
  );

  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [isFormdateDirty, setIsFormDateDirty] = useState(false);
  const [isStartDateGreater, setIsStartDateGreater] = useState(false);
  const [noDataForFlowsheet, setNoDataForFlowsheet] = useState(true);
  const [FlowSheetGridParams, setFlowSheetGridParams] = useState();
  const [showDatagrid, setShowDatagrid] = useState(false);
  const [mainColumns, setMainColumns] = React.useState<any>([]);
  const [dropdownValues, setDropdownValues] = useState<any>({});
  const [data, setData] = useState([]);
  const getLocalStorageData = AuthUtils.getSelectedCheckBoxData();
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();

  const methods = useForm({});

  const {
    control,
    handleSubmit,
    reset,
    setError,
    clearErrors,
    formState: {errors}
  } = methods;

  const [vitalDataGrid, setVitalDataGrid] = React.useState<boolean>(false);
  const [dialogLoader, setDialogLoader] = React.useState<boolean>(false);
  const [openDialog, setOpenDialog] = React.useState({
    viewDialog: false
  });
  const [totalRowCount, setTotalRowCount] = React.useState(0);
  const [dialogInfo, setDialogInfo] = React.useState<any>({
    dialogDescription: ''
  });

  const localSearch = EncryptUtils.getDecryptedData(
    location?.search,
    LOCAL_SEARCH
  );
  const parsedLocalSearch = localSearch ? JSON.parse(localSearch) : {};

  const isLocalSearchActive =
    Object.keys(parsedLocalSearch)?.length > 0 &&
    parsedLocalSearch?.is_local_search;

  const dialogClose = () => {
    setOpenDialog(() => ({
      viewDialog: false
    }));

    setDialogLoader(false);
  };

  const getHeaderNameForFlowsheet = (key: any) => {
    if (key === FormConstants.FLOWSHEETS_SCREENS.PARAMETER_NAME) {
      return FormConstants.FLOWSHEETS_SCREENS.Parameter_Name;
    }
    if (key === FormConstants.FLOWSHEETS_SCREENS.FLOWSHEET_TYPE) {
      return FormConstants.FLOWSHEETS_SCREENS.Flowsheet_Type;
    }
    return key;
  };

  const getHeaderNameForVitals = (key: any) => {
    if (key === FormConstants.VITAL_FIELDS_MAPPING.VITAL_NAME) {
      return FormConstants.VITAL_FIELDS_MAPPING.VitalName;
    }
    return key;
  };

  const getSortAndFilterStatusForFlowSheets = (key: any) => {
    return [
      FormConstants.FLOWSHEETS_SCREENS.PARAMETER_NAME,
      FormConstants.FLOWSHEETS_SCREENS.FLOWSHEET_TYPE
    ].includes(key);
  };

  const getSortAndFilterStatusForVitals = (key: any) => {
    return key === FormConstants.VITAL_FIELDS_MAPPING.VITAL_NAME;
  };

  const getUpdatedColumns = (columnItem: any, inputName: any) => {
    const columnList: any = [];
    Object.entries(columnItem).forEach(([key, value]) => {
      if (inputName === FormConstants.SCREENS.FLOWSHEETS) {
        const obj = {
          field: key,
          headerName: getHeaderNameForFlowsheet(key),
          width: 180,
          valueGetter: (data: any) =>
            data.type === FormConstants.CONFIG_FIELDS_TYPE.DATE ||
            data.type === FormConstants.CONFIG_FIELDS_TYPE.DATE_TIME
              ? new Date(data.value)
              : data.value,
          renderCell: (ele: any) => {
            const cellValue = ele?.value ?? ''; // Ensure cellValue is a string
            const isPointer =
              typeof cellValue === 'string' &&
              cellValue.includes(FormConstants.FLOWSHEETS_SCREENS.ID_KEY);
            return (
              <Typography
                sx={{
                  cursor: isPointer ? 'pointer' : 'default'
                }}
                color={isPointer ? 'primary' : ''}>
                {isPointer
                  ? cellValue.split(
                      FormConstants.FLOWSHEETS_SCREENS.ID_KEY
                    )?.[0]
                  : cellValue}
              </Typography>
            );
          },
          sortable: getSortAndFilterStatusForFlowSheets(key),
          filterable: getSortAndFilterStatusForFlowSheets(key)
        };

        columnList.push(obj);
      } else {
        const obj = {
          field: key,
          headerName: getHeaderNameForVitals(key),
          width: 180,
          valueGetter: (data: any) =>
            data.type === FormConstants.CONFIG_FIELDS_TYPE.DATE ||
            data.type === FormConstants.CONFIG_FIELDS_TYPE.DATE_TIME
              ? new Date(data.value)
              : data.value,
          renderCell: (ele: any) => {
            return (
              <Typography
                sx={{
                  cursor: ele?.value?.includes(
                    FormConstants.VITAL_SCREENS.ID_KEY
                  )
                    ? 'pointer'
                    : 'default'
                }}
                color={
                  ele?.value?.includes(FormConstants.VITAL_SCREENS.ID_KEY)
                    ? 'primary'
                    : ''
                }>
                {ele?.value?.split(FormConstants.VITAL_SCREENS.ID_KEY)?.[0]}
              </Typography>
            );
          },
          sortable: getSortAndFilterStatusForVitals(key),
          filterable: getSortAndFilterStatusForVitals(key)
        };

        columnList.push(obj);
      }
    });
    return columnList;
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const logVitalsResults = (dataObj: any) => {
    let subModuleIdentifier = '';
    let eventDescription = '';

    if (dataObj.parentLegacyApp) {
      subModuleIdentifier += `LegacyApp: ${dataObj.parentLegacyApp},`;
    }
    if (dataObj.StartDate) {
      subModuleIdentifier += ` StartDate: ${dataObj.StartDate},`;
    }
    if (dataObj.StopDate) {
      subModuleIdentifier += ` StopDate: ${dataObj.StopDate},`;
    }

    if (dataObj.FlowsheetGroup) {
      subModuleIdentifier += ` FlowsheetGroup: ${dataObj.FlowsheetGroup},`;
    }

    if (dataObj?.sql_data?.audit_event_description) {
      eventDescription = `${dataObj?.sql_data?.audit_event_description}`;
    }

    const data = {
      module: params.module_name,
      sub_module: params.submodule_name,
      sub_module_identifier: subModuleIdentifier,
      application_name: applicationName,
      isBH_selected: !isBHReason?.length && isBH == false ? true : isBH,
      isBH_reason: isBHReason,
      event_description: eventDescription,
      audit_identifier: AuthUtils.getAuditIdentifier(),
      audit_identifier_type: AuthUtils.getAuditIdentifierType(),
      audit_legacy_app: AuthUtils.getAuditLegacyApp()
    };
    createAuditLog(params.module_name, data);
  };

  const onSubmit = async (dataObj: any) => {
    // Avoid making the first API call when switching from "Flowsheets" to "Vitals" while Discrete Search is active,
    // because `sectionUIData` contains outdated data. Specifically, if:
    // - Local search is active (`isLocalSearchActive` is true),
    // - The submodule being accessed is "vital" (`params?.submodule_name === 'vital'),
    // - And the current section's UI data (`sectionUIData`) indicates the user was previously viewing Flowsheets
    //   (`sectionUIData?.sub_sections?.sql_data?.audit_event_description === 'Viewed Flowsheets'),
    // we skip the API call to prevent fetching and displaying stale data.
    if (
      isLocalSearchActive &&
      params?.submodule_name === 'vital' &&
      sectionUIData?.sub_sections?.sql_data?.audit_event_description ===
        'Viewed Flowsheets'
    ) {
      return;
    }
    if (
      params?.submodule_name === 'flowsheets' &&
      selectName.legacy_group?.length &&
      selectName.flowsheet_group?.length
    ) {
      // dataObj.flowsheet_group = selectName.flowsheet_group;
      dataObj.legacy_group = selectName.legacy_group;
      delete dataObj.legacy_system;
    }
    try {
      const start_date =
        dataObj?.start_date != null ? new Date(dataObj?.start_date) : '';
      const stop_date =
        dataObj?.stop_date != null ? new Date(dataObj.stop_date) : '';
      const startDate = start_date && start_date.toLocaleDateString('en-US');
      const endDate = stop_date && stop_date.toLocaleDateString('en-US');
      let dateerror;
      if (startDate) {
        dateerror = true;
      }
      if (endDate) {
        dateerror = true;
      }
      if (startDate && endDate) {
        const startDateParsed = moment(startDate, 'M/D/YYYY HH:mm:ss'); // Assuming format is 'M/D/YYYY HH:mm:ss'
        const endDateParsed = moment(endDate, 'M/D/YYYY HH:mm:ss'); // Assuming format is 'M/D/YYYY HH:mm:ss'
        if (startDateParsed.isAfter(endDateParsed)) {
          dateerror = true;
        } else if (startDateParsed.isBefore(endDateParsed)) {
          dateerror = false;
        } else {
          dateerror = false;
        }
      }
      if (startDate === null || endDate === null || dateerror) {
        setIsFormDateDirty(true);
        setIsStartDateGreater(true);
        return;
      }
      if (!startDate?.length && !endDate?.length) {
        setIsFormDirty(true);
        return;
      }
      setShowError(false);

      if (
        params?.module_name &&
        params?.submodule_name === 'transfusion' &&
        sectionUIData?.sub_sections
      ) {
        // Determine which sql_data to use
        const sql_data = isLocalSearchActive
          ? sectionUIData?.sub_sections?.discrete_search_sql_data
          : sectionUIData?.sub_sections?.sql_data;

        if (sql_data?.sql && sql_data?.variables) {
          const values: any = {
            sql_data: sql_data,
            values: record_id,
            user_id: record_id,
            parentLegacyApp: ParentLegacyValue || '',
            TransfusionID: rowId,
            StartDate: startDate, // '04/06/2011'
            StopDate: endDate, // '05/20/2011'
            audit_sub_module_identifier: isLocalSearchActive
              ? `${
                  dataObj?.flowsheet_group
                    ? `FlowsheetGroup: ${dataObj?.flowsheet_group}`
                    : ''
                }, Date: ${startDate} to ${endDate}`
              : `${
                  selectName?.flowsheet_group
                    ? `FlowsheetGroup: ${selectName?.flowsheet_group}`
                    : ''
                }, Date: ${startDate} to ${endDate}`,
            isBH_selected:
              !isBHReason?.length && isBH == false ? 'true' : isBH.toString(),
            isBH_reason: isBHReason,
            application_name: applicationName
          };

          if (params?.submodule_name === FormConstants.SCREENS.TRANSFUSION) {
            const formDirty = !values.StartDate || !values.StopDate;
            setIsFormDirty(formDirty);
            if (formDirty) {
              return;
            }
          }
          values.LegacyAppGroup = dataObj?.legacy_group || '';
          values.audit_identifier = AuthUtils.getAuditIdentifier();
          values.audit_identifier_type = AuthUtils.getAuditIdentifierType();
          values.audit_legacy_app = AuthUtils.getAuditLegacyApp();
          if (params?.submodule_name === FormConstants.SCREENS.TRANSFUSION) {
            if (sectionUIData?.sub_sections?.sql_data?.filter_schema_clause) {
              values.filter_schema_clause =
                sectionUIData?.sub_sections?.sql_data?.filter_schema_clause;
            }
            if (
              sectionUIData?.is_filter_sql_required &&
              getLocalStorageData.length > 0
            ) {
              values.filter_data = getLocalStorageData;
            }
          }

          if (isLocalSearchActive && parsedLocalSearch?.ID) {
            values.local_search = isLocalSearchActive;
            values.local_search_ID = parsedLocalSearch?.ID;
          }
          const encryptRequestData = EncryptUtils.encryptedData(values);
          setShowDatagrid(true);

          setNoDataForFlowsheet(false);
          setData([]);
          setMainColumns([]);
          const result = await getPageData(
            applicationName,
            params?.module_name,
            params?.submodule_name,
            {tk: encryptRequestData}
          );

          setData(result.count[0].count === 0 ? [] : result?.data);
          setTotalRowCount(result.count[0].count);
          const columns = getUpdatedColumns(
            result?.data?.[0] || [],
            params?.submodule_name
          );

          setMainColumns(result.count[0].count === 0 ? [] : columns);

          setShowDatagrid(false);
        }
      } else if (
        params?.module_name === 'lis' &&
        params?.submodule_name === 'productinfo' &&
        sectionUIData?.sub_sections
      ) {
        console.log('onSunmit', sectionUIData?.sub_sections);

        // Determine which sql_data to use
        const sql_data = isLocalSearchActive
          ? sectionUIData?.sub_sections?.discrete_search_sql_data
          : sectionUIData?.sub_sections?.sql_data;

        if (sql_data?.sql && sql_data?.variables) {
          const values: any = {
            sql_data: sql_data,
            values: record_id,
            user_id: record_id,
            parentLegacyApp: ParentLegacyValue || '',
            TransfusionID: rowId,
            StartDate: startDate, // '04/06/2011'
            StopDate: endDate, // '05/20/2011'
            audit_sub_module_identifier: isLocalSearchActive
              ? `${
                  dataObj?.flowsheet_group
                    ? `FlowsheetGroup: ${dataObj?.flowsheet_group}`
                    : ''
                }, Date: ${startDate} to ${endDate}`
              : `${
                  selectName?.flowsheet_group
                    ? `FlowsheetGroup: ${selectName?.flowsheet_group}`
                    : ''
                }, Product Info Vitals Date: ${startDate} to ${endDate}`,
            isBH_selected:
              !isBHReason?.length && isBH == false ? 'true' : isBH.toString(),
            isBH_reason: isBHReason,
            application_name: applicationName
          };

          if (params?.submodule_name === FormConstants.SCREENS.TRANSFUSION) {
            const formDirty = !values.StartDate || !values.StopDate;
            setIsFormDirty(formDirty);
            if (formDirty) {
              return;
            }
          }
          values.LegacyAppGroup = dataObj?.legacy_group || '';
          values.audit_identifier = AuthUtils.getAuditIdentifier();
          values.audit_identifier_type = AuthUtils.getAuditIdentifierType();
          values.audit_legacy_app = AuthUtils.getAuditLegacyApp();
          if (params?.submodule_name === FormConstants.SCREENS.TRANSFUSION) {
            if (sectionUIData?.sub_sections?.sql_data?.filter_schema_clause) {
              values.filter_schema_clause =
                sectionUIData?.sub_sections?.sql_data?.filter_schema_clause;
            }
            if (
              sectionUIData?.is_filter_sql_required &&
              getLocalStorageData.length > 0
            ) {
              values.filter_data = getLocalStorageData;
            }
          }

          if (isLocalSearchActive && parsedLocalSearch?.ID) {
            values.local_search = isLocalSearchActive;
            values.local_search_ID = parsedLocalSearch?.ID;
          }
          const encryptRequestData = EncryptUtils.encryptedData(values);
          setShowDatagrid(true);

          setNoDataForFlowsheet(false);
          setData([]);
          setMainColumns([]);
          const result = await getPageData(
            applicationName,
            params?.module_name,
            params?.submodule_name,
            {tk: encryptRequestData}
          );

          setData(result.count[0].count === 0 ? [] : result?.data);
          setTotalRowCount(result.count[0].count);
          const columns = getUpdatedColumns(
            result?.data?.[0] || [],
            params?.submodule_name
          );

          setMainColumns(result.count[0].count === 0 ? [] : columns);

          setShowDatagrid(false);
        }
      } else if (
        params?.module_name &&
        params?.submodule_name &&
        sectionUIData?.sub_sections
      ) {
        // Determine which sql_data to use
        const sql_data = isLocalSearchActive
          ? sectionUIData?.sub_sections?.discrete_search_sql_data
          : sectionUIData?.sub_sections?.sql_data;

        if (sql_data?.sql && sql_data?.variables) {
          const values: any = {
            sql_data: sql_data,
            values: record_id,
            user_id: record_id,
            parentLegacyApp: isLocalSearchActive
              ? dataObj?.LegacyApp
              : ParentLegacyValue || dataObj?.legacy_group || '',
            FlowsheetGroup: isLocalSearchActive
              ? dataObj?.flowsheet_group
              : dataObj?.flowsheet_group ||
                selectName?.flowsheet_group ||
                selectName?.FlowsheetGroup,
            // LegacyAppGroup: dataObj?.legacy_group || '',
            StartDate: startDate, // '04/06/2011'
            StopDate: endDate, // '05/20/2011'
            audit_sub_module_identifier: isLocalSearchActive
              ? `${
                  dataObj?.flowsheet_group
                    ? `FlowsheetGroup: ${dataObj?.flowsheet_group}`
                    : ''
                }, Date: ${startDate} to ${endDate}`
              : `${
                  selectName?.flowsheet_group
                    ? `FlowsheetGroup: ${selectName?.flowsheet_group}`
                    : ''
                }, Date: ${startDate} to ${endDate}`
            // isBH_reason: isBHReason,
            // application_name: applicationName
          };

          // Exclude LegacyAppGroup if isLocalSearchActive is true
          // const filteredValues = isLocalSearchActive
          //   ? Object.fromEntries(
          //       Object.entries(values).filter(([key]) => key !== 'LegacyAppGroup')
          //     )
          //   : values;

          if (params?.submodule_name === FormConstants.SCREENS.FLOWSHEETS) {
            const formDirty = Object.values(values).some(v => v === '');
            setIsFormDirty(formDirty);
            if (formDirty) {
              return;
            }
          }

          values.LegacyAppGroup = dataObj?.legacy_group || '';
          values.audit_identifier = AuthUtils.getAuditIdentifier();
          values.audit_identifier_type = AuthUtils.getAuditIdentifierType();
          values.audit_legacy_app = AuthUtils.getAuditLegacyApp();

          if (params?.submodule_name === FormConstants.SCREENS.VITAL) {
            if (sectionUIData?.sub_sections?.sql_data?.filter_schema_clause) {
              values.filter_schema_clause =
                sectionUIData?.sub_sections?.sql_data?.filter_schema_clause;
            }
            if (
              sectionUIData?.is_filter_sql_required &&
              getLocalStorageData.length > 0
            ) {
              values.filter_data = getLocalStorageData;
            }
          }

          if (isLocalSearchActive && parsedLocalSearch?.ID) {
            values.local_search = isLocalSearchActive;
            values.local_search_ID = parsedLocalSearch?.ID;
          }
          (values.isBH_selected = isBH),
            (values.isBH_reason = isBHReason),
            (values.application_name = applicationName);

          const encryptRequestData = EncryptUtils.encryptedData(values);
          setShowDatagrid(true);

          setNoDataForFlowsheet(false);
          setData([]);
          setMainColumns([]);
          const result = await getPageData(
            applicationName,
            params?.module_name,
            params?.submodule_name,
            {tk: encryptRequestData}
          );

          setData(result.count[0].count === 0 ? [] : result?.data);
          setTotalRowCount(result.count[0].count);
          const columns = getUpdatedColumns(
            result?.data?.[0] || [],
            params?.submodule_name
          );

          setMainColumns(result.count[0].count === 0 ? [] : columns);

          setShowDatagrid(false);
        }
      }
    } catch (e) {
      const errMessage = getErrorMessage(e);
      if (errMessage === 'Exceeded the maximum allowed items.') {
        setShowError(true);
      } else {
        enqueueSnackbar(errMessage, SnackBarConfig.getError());
      }
      setShowDatagrid(false);
    }
  };

  // for filterig date range the with encounter number.
  const [localEncounterData, setLocalEncounterData] = useState<string | any>(
    null
  );

  useEffect(() => {
    const encounterData = AuthUtils.getSelectedCheckBoxData();
    setLocalEncounterData(encounterData);
  }, []);

  const SendEncounterNumber = () => {
    let filterEncounterNumber: any;
    const filteredArray: any = [];
    let parsedData;

    try {
      parsedData = JSON.parse(localEncounterData);
    } catch (error) {
      console.error('Error parsing localStorage data:', error);
    }
    if (parsedData) {
      filterEncounterNumber = JSON.parse(localEncounterData);
      filterEncounterNumber?.map((entry: any) =>
        filteredArray.push(entry.EncounterNumber)
      );
    }
    return filteredArray;
  };
  // end

  useEffect(() => {
    if (
      selectName.legacy_group?.length &&
      !selectName.flowsheet_group?.length &&
      !(selectName.start_date?.length && selectName.stop_date?.length)
    ) {
      setIsLoading(true);
      // eslint-disable-next-line no-use-before-define
      renderDropDownOptions('flowsheet_group');
      setIsLoading(false);
    }
    if (
      selectName.legacy_group?.length &&
      selectName.flowsheet_group?.length &&
      !(selectName.start_date?.length && selectName.stop_date?.length)
    ) {
      // eslint-disable-next-line no-use-before-define
      renderDropDownOptions();
    }

    if (
      params?.module_name === 'clinical' &&
      params?.submodule_name === 'transfusion' &&
      !selectName.start_date?.length &&
      !selectName.stop_date?.length
    ) {
      setIsLoading(true);
      renderDropDownOptions(null, true);
    }
    if (
      params?.module_name === 'lis' &&
      params?.submodule_name === 'productinfo' &&
      !selectName.start_date?.length &&
      !selectName.stop_date?.length
    ) {
      console.log('we are inside Vitalss');

      setIsLoading(true);
      renderDropDownOptions(null, true);
    }
  }, [
    selectName.flowsheet_group,
    selectName.legacy_group,
    selectName.start_date,
    selectName.stop_date,
    params?.module_name,
    params?.submodule_name
  ]);
  const renderDropDownOptions = async (newValue?: any, dateRange = false) => {
    Object.entries(sectionUIData?.fields).forEach(
      async (item: any, index: number) => {
        if (
          selectName?.legacy_group &&
          newValue == 'flowsheet_group' &&
          item[1]?.flowsheet_group_sql_data?.sql &&
          !dateRange
        ) {
          const values = {
            sql_data: item[1].flowsheet_group_sql_data,
            values: record_id,
            user_id: record_id,
            localEncounterNumber: SendEncounterNumber(),
            filter_data: localEncounterData,
            // mdoule_namevital: params?.module_name,
            filter_schema_clause: item[1]?.sql_data?.filter_schema_clause,
            ParentLegacyValue: ParentLegacyValue,
            LegacyAppGroup: selectName?.LegacyAppGroup || '',
            flowsheetsubmodule: params?.submodule_name,
            isBH_selected:
              !isBHReason?.length && isBH == false ? 'true' : isBH.toString(),
            isBH_reason: isBHReason,
            application_name: applicationName
          };
          const encryptRequestData = EncryptUtils.encryptedData(values);

          setShowDatagrid(true);
          const result = await getPageData(
            applicationName,
            params?.module_name,
            params?.submodule_name,
            {
              tk: encryptRequestData
            }
          );
          setShowDatagrid(false);
          setDropdownValues((prevState: any) => ({
            ...prevState,
            [item[0]]: result.data
          }));
        } else if (
          params.submodule_name === 'flowsheets' &&
          selectName?.legacy_group &&
          selectName?.flowsheet_group &&
          // newValue == 'flowsheet_group' &&
          item[1]?.date_range_sql_data?.sql
        ) {
          const values = {
            sql_data: item[1].date_range_sql_data,
            values: record_id,
            user_id: record_id,
            localEncounterNumber: SendEncounterNumber(),
            filter_data: localEncounterData,
            // mdoule_namevital: params?.module_name,
            filter_schema_clause: item[1]?.sql_data?.filter_schema_clause,
            ParentLegacyValue: ParentLegacyValue,
            LegacyAppGroup: selectName?.LegacyAppGroup || '',
            FlowsheetGroup: newValue || selectName.FlowsheetGroup || '',
            flowsheetsubmodule: params?.submodule_name,
            isBH_selected:
              !isBHReason?.length && isBH == false ? 'true' : isBH.toString(),
            isBH_reason: isBHReason,
            application_name: applicationName
          };
          const encryptRequestData = EncryptUtils.encryptedData(values);

          setShowDatagrid(true);
          const result = await getPageData(
            applicationName,
            params?.module_name,
            params?.submodule_name,
            {
              tk: encryptRequestData
            }
          );
          setShowDatagrid(false);

          // Date range functionality
          const {startdate, enddate} = result.data[0];
          const formattedStartDate = moment(new Date(startdate)).format(
            'MM/DD/YYYY'
          );
          const formattedEndDate = moment(new Date(enddate)).format(
            'MM/DD/YYYY'
          );

          // Update both state and form values
          await setSelectName(prevState => ({
            ...prevState,
            start_date: formattedStartDate,
            stop_date: formattedEndDate
          }));
          methods.setValue('start_date', formattedStartDate);
          methods.setValue('stop_date', formattedEndDate);

          // // Trigger form submission after processing the date range data
          if (formattedStartDate && formattedEndDate) {
            handleSubmit(onSubmit)();
          }
        } else if (
          !selectName?.legacy_group &&
          item[1]?.sql_data?.sql &&
          !dateRange
        ) {
          const values = {
            sql_data: item[1].sql_data,
            values: record_id,
            user_id: record_id,
            localEncounterNumber: SendEncounterNumber(),
            filter_data: localEncounterData,
            // mdoule_namevital: params?.module_name,
            filter_schema_clause: item[1]?.sql_data?.filter_schema_clause,
            ParentLegacyValue: ParentLegacyValue,
            flowsheetsubmodule: params?.submodule_name,
            isBH_selected:
              !isBHReason?.length && isBH == false ? 'true' : isBH.toString(),
            isBH_reason: isBHReason,
            application_name: applicationName
          };
          const encryptRequestData = EncryptUtils.encryptedData(values);

          setShowDatagrid(true);
          const result = await getPageData(
            applicationName,
            params?.module_name,
            params?.submodule_name,
            {
              tk: encryptRequestData
            }
          );
          setShowDatagrid(false);
          setDropdownValues((prevState: any) => ({
            ...prevState,
            [item[0]]: result.data
          }));
        } else if (
          params.submodule_name !== 'flowsheets' &&
          item[1]?.date_range_sql_data?.sql &&
          dateRange
        ) {
          setIsLoading(true);
          setData([]);
          setMainColumns([]);

          const values = {
            sql_data: item[1].date_range_sql_data,
            values: record_id,
            user_id: record_id,
            localEncounterNumber: SendEncounterNumber(),
            filter_data: localEncounterData,
            mdoule_namevital: params?.module_name,
            vital_legacy_app: newValue ?? selectName.flowsheet_group,
            filter_schema_clause:
              item[1]?.date_range_sql_data?.filter_schema_clause,
            ParentLegacyValue: ParentLegacyValue,
            flowsheetsubmodule: params?.submodule_name,
            isBH_selected:
              !isBHReason?.length && isBH == false ? 'true' : isBH.toString(),
            isBH_reason: isBHReason,
            application_name: applicationName
          };

          const encryptRequestData = EncryptUtils.encryptedData(values);

          try {
            const result = await getPageData(
              applicationName,
              params?.module_name,
              params?.submodule_name,
              {
                tk: encryptRequestData
              }
            );

            const {startdate, enddate} = result.data[0];

            // Function to format date if not null/undefined
            const formatIfNotNull = (date: any) => {
              if (date) {
                return moment.utc(date).format('MM/DD/YYYY');
              } else {
                return ''; // Or any other fallback value you consider appropriate
              }
            };

            const formattedStartDate = formatIfNotNull(startdate);
            const formattedEndDate = formatIfNotNull(enddate);

            // Update both state and form values
            setSelectName(prevState => ({
              ...prevState,
              start_date: formattedStartDate,
              stop_date: formattedEndDate
            }));
            methods.setValue('flowsheet_group', newValue);
            methods.setValue('start_date', formattedStartDate);
            methods.setValue('stop_date', formattedEndDate);

            // Only trigger form submission if both start and end dates are not empty
            if (formattedStartDate && formattedEndDate) {
              handleSubmit(onSubmit)();
            } else {
              console.log('Date is not Available');
            }
          } catch (error) {
            console.error('Error fetching date range data:', error);
          } finally {
            setIsLoading(false);
          }
        } else if (
          params?.module_name === 'clinical' &&
          params?.submodule_name === 'transfusion' &&
          !dateRange &&
          sectionUIData?.sub_sections?.date_range_sql_data?.sql
        ) {
          const sql_data_to_use =
            sectionUIData.sub_sections.date_range_sql_data;
          const values = {
            sql_data: sql_data_to_use,
            values: record_id,
            user_id: record_id,
            localEncounterNumber: SendEncounterNumber(),
            filter_data: localEncounterData,
            filter_schema_clause: sql_data_to_use?.filter_schema_clause,
            parentLegacyApp: ParentLegacyValue,
            isBH_selected:
              !isBHReason?.length && isBH == false ? 'true' : isBH.toString(),
            isBH_reason: isBHReason,
            application_name: applicationName,
            TransfusionID: rowId
          };
          const encryptRequestData = EncryptUtils.encryptedData(values);
          try {
            setShowDatagrid(true);
            const result = await getPageData(
              applicationName,
              params?.module_name,
              params?.submodule_name,
              {
                tk: encryptRequestData
              }
            );
            const {startdate, enddate} = result.data[0];
            const formatIfNotNull = (date: any) => {
              if (date) {
                return moment.utc(date).format('MM/DD/YYYY');
              } else {
                return '';
              }
            };
            const formattedStartDate = formatIfNotNull(startdate);
            const formattedEndDate = formatIfNotNull(enddate);
            await setSelectName(prevState => ({
              ...prevState,
              start_date: formattedStartDate,
              stop_date: formattedEndDate
            }));
            methods.setValue('start_date', formattedStartDate);
            methods.setValue('stop_date', formattedEndDate);
            if (formattedStartDate && formattedEndDate) {
              handleSubmit(onSubmit)();
            } else {
              console.log('Date is not Available');
            }
          } catch (error) {
            console.error('Error fetching date range data:', error);
          } finally {
            setIsLoading(false);
            setShowDatagrid(false);
          }
        } else if (
          params?.module_name === 'lis' &&
          params?.submodule_name === 'productinfo' &&
          !dateRange &&
          sectionUIData?.sub_sections?.date_range_sql_data?.sql
        ) {
          console.log('innner render dop');

          const sql_data_to_use =
            sectionUIData.sub_sections.date_range_sql_data;
          const values = {
            sql_data: sql_data_to_use,
            values: record_id,
            user_id: record_id,
            localEncounterNumber: SendEncounterNumber(),
            filter_data: localEncounterData,
            filter_schema_clause: sql_data_to_use?.filter_schema_clause,
            parentLegacyApp: ParentLegacyValue,
            isBH_selected:
              !isBHReason?.length && isBH == false ? 'true' : isBH.toString(),
            isBH_reason: isBHReason,
            application_name: applicationName,
            TransfusionID: rowId
          };
          console.log('productinfo', values);
          const encryptRequestData = EncryptUtils.encryptedData(values);
          try {
            setShowDatagrid(true);
            const result = await getPageData(
              applicationName,
              params?.module_name,
              params?.submodule_name,
              {
                tk: encryptRequestData
              }
            );
            const {startdate, enddate} = result.data[0];
            const formatIfNotNull = (date: any) => {
              if (date) {
                return moment.utc(date).format('MM/DD/YYYY');
              } else {
                return '';
              }
            };
            const formattedStartDate = formatIfNotNull(startdate);
            const formattedEndDate = formatIfNotNull(enddate);
            await setSelectName(prevState => ({
              ...prevState,
              start_date: formattedStartDate,
              stop_date: formattedEndDate
            }));
            methods.setValue('start_date', formattedStartDate);
            methods.setValue('stop_date', formattedEndDate);
            if (formattedStartDate && formattedEndDate) {
              handleSubmit(onSubmit)();
            } else {
              console.log('Date is not Available');
            }
          } catch (error) {
            console.error('Error fetching date range data:', error);
          } finally {
            setIsLoading(false);
            setShowDatagrid(false);
          }
        }
      }
    );
  };

  const handleSelectChange = async (newValue: any, inputName: string) => {
    if (inputName === FormConstants.FLOWSHEETS_SCREENS.FLOWSHEET_GROUP) {
      setSelectName(prevState => ({
        ...prevState,
        flowsheet_group: newValue,
        FlowsheetGroup: newValue,
        start_date: '',
        stop_date: ''
      }));
      if (
        params.module_name === 'clinical' &&
        (params.submodule_name === 'vital' ||
          params.submodule_name === 'flowsheets')
      ) {
        const dateRange = true;
        methods.setValue('start_date', '');
        methods.setValue('stop_date', '');
        methods.setValue('flowsheet_group', newValue);

        renderDropDownOptions(newValue, dateRange);
      }
    } else if (inputName === 'legacy_group') {
      setSelectName(prevState => ({
        ...prevState,
        flowsheet_group: '',
        FlowsheetGroup: '',
        start_date: '',
        stop_date: '',
        legacy_group: newValue,
        LegacyAppGroup: newValue
      }));
      // Sync all RHF form fields so controlled components (RHFAutocomplete) visually reset
      methods.setValue('legacy_group', newValue);
      methods.setValue('flowsheet_group', '');
      methods.setValue('start_date', '');
      methods.setValue('stop_date', '');
      // Wipe stale Flowsheet Group dropdown options so they are re-fetched for the new legacy app
      setDropdownValues((prev: any) => ({...prev, flowsheet_group: []}));
      // Clear results table
      setData([]);
      setMainColumns([]);
      // Reset UI flags (same as onReset)
      setIsFormDirty(false);
      setShowError(false);
      setNoDataForFlowsheet(true);
    } else {
      setSelectName(prevState => ({
        ...prevState,
        legacy_system: newValue
      }));
    }
  };

  const onReset = useCallback(() => {
    reset({
      legacy_system: '',
      legacy_group: '',
      flowsheet_group: '',
      user_id: record_id,
      ID: record_id,
      start_date: '',
      stop_date: ''
    });
    setSelectName(() => ({
      legacy_system: '',
      legacy_group: '',
      flowsheet_group: '',
      FlowsheetGroup: '', // Added this missing property
      LegacyAppGroup: '', // Added this missing property
      user_id: record_id,
      ID: record_id,
      start_date: '',
      stop_date: ''
    }));
    onSubmit({});
    setData([]);
    setMainColumns([]);
    setIsFormDirty(false);
    setShowError(false);
    setNoDataForFlowsheet(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isLocalSearchActive) {
      onSubmit(parsedLocalSearch?.data);
    } else {
      onReset();
    }
  }, [location?.search]);

  useEffect(() => {
    if (
      params?.submodule_name === FormConstants.SCREENS.FLOWSHEETS ||
      params?.submodule_name === FormConstants.SCREENS.VITAL
    ) {
      onReset();
      // Wipe stale Flowsheet Group dropdown options so they re-fetch for the new Legacy App
      setDropdownValues((prev: any) => ({...prev, flowsheet_group: []}));
    }
    if (!isLocalSearchActive) {
      renderDropDownOptions();
    }
  }, [
    ParentLegacyValue,
    sectionUIData?.sub_sections?.sql_data?.sql,
    sectionUIData?.update_is_enable_sql,
    sectionUIData
  ]);

  const handleCellClick = async (gridParams: any) => {
    setVitalDataGrid(false);
    if (
      gridParams.field === FormConstants.VITAL_SCREENS.VITAL_NAME_COLUMN ||
      gridParams.field ===
        FormConstants.FLOWSHEETS_SCREENS.FLOWSHEET_TYPE_COLUMN ||
      gridParams.field === FormConstants.FLOWSHEETS_SCREENS.FLOWSHEET_TYPE ||
      gridParams.field === FormConstants.FLOWSHEETS_SCREENS.PARAMETER_NAME ||
      !gridParams?.value
    ) {
      return;
    }

    const id = gridParams?.value?.split(
      FormConstants.FLOWSHEETS_SCREENS.ID_KEY
    )[1];

    setFlowSheetGridParams(gridParams);

    setOpenDialog(() => ({
      viewDialog: true
    }));
    setDialogLoader(true);

    const cardPayload = {
      sql_data: sectionUIData?.sub_sections?.sub_sections?.[0]?.sql_data,
      id,
      isBH_selected:
        !isBHReason?.length && isBH == false ? 'true' : isBH.toString(),
      isBH_reason: isBHReason,
      application_name: applicationName
    };
    const encryptRequestCardData = EncryptUtils.encryptedData(cardPayload);

    const cardRes = await getPageData(
      applicationName,
      params?.module_name,
      params?.submodule_name,
      {
        tk: encryptRequestCardData
      }
    );
    const [cardConfig, gridConfig] =
      sectionUIData?.sub_sections?.sub_sections || [];

    let gridRes;

    if (
      params?.submodule_name !== FormConstants.SCREENS.FLOWSHEETS &&
      params?.submodule_name !== FormConstants.SCREENS.TRANSFUSION &&
      params?.submodule_name !== FormConstants.SCREENS.PRODUCTINFO
    ) {
      const gridPayload = {
        sql_data: sectionUIData?.sub_sections?.sub_sections?.[1]?.sql_data,
        id,
        isBH_selected:
          !isBHReason?.length && isBH == false ? 'true' : isBH.toString(),
        isBH_reason: isBHReason,
        application_name: applicationName
      };
      const encryptRequestGridData = EncryptUtils.encryptedData(gridPayload);
      gridRes = await getPageData(
        applicationName,
        params?.module_name,
        params?.submodule_name,
        {
          tk: encryptRequestGridData
        }
      );
    }
    if (gridRes?.data.length) setVitalDataGrid(true);
    setDialogLoader(false);
    setDialogInfo({
      dialogDescription: dialogLoader ? (
        <ComponentLoader />
      ) : (
        <>
          <CardComponent
            module={params?.module_name}
            sectionUIData={{}}
            fields={cardConfig?.fields}
            is_colon_needed={true}
            data={cardRes?.data}
            is_border_required={false}
            component_type="document"
            columns_per_row={1}
          />
          {gridRes?.data.length ? (
            <CollapsibleTable
              sectionUIData={gridConfig}
              sectionRowsData={gridRes?.data}
            />
          ) : null}
        </>
      )
    });
  };

  const getPageCount = (rowCount: number, pageSize: number): number => {
    if (pageSize > 0 && rowCount > 0) {
      return Math.ceil(rowCount / pageSize);
    }
    return 0;
  };

  function CustomPagination() {
    const gridApiContext = useGridApiContext();

    const [pageSize, setPageSize] = React.useState(
      useGridSelector(gridApiContext, gridPageSizeSelector)
    );
    const [pageSizes, setPageSizes] = React.useState(
      useGridSelector(gridApiContext, gridPageSizeSelector)
    );

    const page = useGridSelector(gridApiContext, gridPageSelector);
    const rowCount = useGridSelector(gridApiContext, gridRowCountSelector);
    const pageCount = getPageCount(rowCount, pageSize);

    const handleChangePage = (event: any, newPage: number) => {
      gridApiContext.current.setPage(newPage);
    };

    const handleChangePageSize = (event: any) => {
      setPageSizes(parseInt(event.target.value, 10));
      gridApiContext.current.setPage(0);
    };

    React.useEffect(() => {
      gridApiContext.current.setPageSize(pageSizes);
      setPageSize(pageSizes);
    }, [pageSizes]);

    return (
      <>
        <RowsCountDivStyle>{`Total Rows: ${totalRowCount}`}</RowsCountDivStyle>
        <GridPagination
          ActionsComponent={paginationProps => (
            <MuiPagination
              className="pp"
              color="primary"
              count={pageCount}
              page={page + 1}
              showFirstButton
              showLastButton
              onChange={(event: any, value: any) =>
                gridApiContext.current.setPage(value - 1)
              }
              siblingCount={1}
              boundaryCount={0}
            />
          )}
          className="pagination-container"
          component="div"
          count={rowCount}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={pageSize}
          onRowsPerPageChange={handleChangePageSize}
          rowsPerPageOptions={environment.rowsvitalPerPageOptions}
        />
      </>
    );
  }

  const renderDatagridComponent = () => {
    return (
      <DataGridComponentDiv>
        <DataGridComponent
          sectionUIData={sectionUIData.sub_sections}
          module={params.module_name}
          sub_module={params.submodule_name}
          columns={mainColumns}
          rowHeight={37}
          rows={data}
          rowThreshold={0}
          initialState={{
            pinnedColumns: {
              left: sectionUIData?.sub_sections?.pinnedColumns
            }
          }}
          groupingColDef={{
            leafField: sectionUIData?.sub_sections?.leaf_field
          }}
          // getRowId={(row: any, index:any) => row.VitalName || row.ParameterName}
          getRowId={(row: any, index: number) => {
            const baseId = row?.VitalName || row?.ParameterName || '';
            return `${baseId}-${index}`;
          }}
          hideFooter={false}
          slots={{
            detailPanelExpandIcon: ExpandMoreOutlined,
            detailPanelCollapseIcon: ExpandLessOutlined,
            toolbar: sectionUIData.is_export_data_needed ? CustomToolbar : '',
            pagination: CustomPagination
          }}
          paginationMode="server"
          sortingMode={totalRowCount <= 40 ? 'client' : 'server'}
          sortingOrder={['desc', 'asc']}
          pageSize={environment?.defaultvitalLimit}
          rowsPerPageOptions={environment?.rowsvitalPerPageOptions}
          autoHeight={false}
          checkboxSelection={sectionUIData.is_selection_needed ? true : false}
          rowsCount={totalRowCount}
          onCellClick={(gridParams: GridCellParams) => {
            handleCellClick(gridParams);
          }}
          TransfusionID={rowId}
          ExpandableRowInFlowSheets={FlowSheetGridParams}
          selectedRowDetails={{
            row: isLocalSearchActive
              ? {
                  legacy_system: parsedLocalSearch?.data?.flowsheet_group,
                  FlowsheetGroup: parsedLocalSearch?.data?.flowsheet_group,
                  LegacyAppGroup:
                    parsedLocalSearch?.data?.LegacyAppGroup ||
                    selectName.LegacyAppGroup,
                  user_id: record_id,
                  ID: record_id,
                  TransfusionID: rowId ? rowId : 6,
                  start_date: new Date(
                    parsedLocalSearch?.data?.start_date
                  ).toLocaleDateString('en-US'),
                  stop_date: new Date(
                    parsedLocalSearch?.data?.stop_date
                  ).toLocaleDateString('en-US'),
                  ParentLegacyValue: parsedLocalSearch?.data?.LegacyApp
                }
              : {...selectName, ParentLegacyValue}
          }}
        />
      </DataGridComponentDiv>
    );
  };

  const renderDateField = (
    inputName: keyof typeof selectName,
    item: any
  ): ReactElement => {
    return (
      <Controller
        name={inputName}
        control={control}
        defaultValue={selectName[inputName] || null}
        render={({field}) => (
          <BasicDatePicker
            value={selectName[inputName] ? dayjs(selectName[inputName]) : null}
            label={item?.heading || ''}
            error={!!errors[inputName]}
            helperText={
              `${errors[inputName]?.message}` || ` ${item?.heading} is required`
            }
            field={field}
            handleChange={date => {
              const parsed = dayjs(date);
              setIsStartDateGreater(false);
              if (parsed.isValid()) {
                const formattedDate = parsed.format('MM/DD/YYYY');
                const fullDateRegex = /^\d{2}\/\d{2}\/\d{4}$/;

                const year = parsed.year();

                // Proceed only if format is correct and year > 1900
                if (fullDateRegex.test(formattedDate) && year > 1900) {
                  setSelectName(prevState => ({
                    ...prevState,
                    [inputName]: formattedDate
                  }));
                  clearErrors(inputName);
                  setIsFormDateDirty(false);
                } else {
                  setError(inputName, {
                    type: 'manual',
                    message: 'Date must be complete and year > 1900'
                  });
                  setIsFormDateDirty(true);
                }
              } else {
                setError(inputName, {
                  type: 'manual',
                  message: 'Invalid date input'
                });
                setIsFormDateDirty(true);
              }
            }}
          />
        )}
      />
    );
  };

  const renderSelectFields = (inputName: string, item: any): ReactElement => {
    const formattedDropdownValues =
      dropdownValues && Array.isArray(dropdownValues[inputName])
        ? dropdownValues[inputName].map((option: any) => ({
            label: option?.[item.value_key] || ''
          }))
        : [];

    // Only force-remount the Flowsheet Group dropdown when Legacy App changes.
    // Applying a changing key to the Legacy App dropdown itself would cause it
    // to unmount mid-selection (since selectName.legacy_group updates on pick).
    const autocompleteKey =
      inputName === 'flowsheet_group'
        ? `flowsheet_group-${selectName.legacy_group}-${ParentLegacyValue}`
        : inputName;

    return (
      <RHFAutocomplete
        key={autocompleteKey}
        name={inputName}
        autoHighlight
        fullWidth
        label={item?.heading || 'Select'}
        placeholder={item.placeholder}
        options={formattedDropdownValues}
        getOptionLabel={(option: any) => option?.label ?? ''}
        isOptionEqualToValue={(opt: any, val: any) => opt?.label === val?.label}
        renderOption={(props, option) => {
          const {onClick, ...rest} = props as any;
          const isSameSelection =
            option.label === (selectName as any)?.[inputName];

          return (
            <li
              {...rest}
              key={option.label}
              onClick={(e: any) => {
                onClick?.(e);
                if (isSameSelection) {
                  handleSelectChange(option.label, inputName);
                }
              }}>
              {option.label}
            </li>
          );
        }}
        onChange={(event, newValue: any) => {
          const selectedValue = newValue?.label ?? '';
          handleSelectChange(selectedValue, inputName);
        }}
        {...(isLoading && {
          InputProps: {
            startAdornment: (
              <InputAdornment position="start">
                <CircularProgress size={20} />
              </InputAdornment>
            )
          }
        })}
      />
    );
  };

  const renderSearchButton = () => {
    return (
      <LoadingButton
        type="submit"
        variant="contained"
        disabled={
          params?.submodule_name === FormConstants.SCREENS.FLOWSHEETS
            ? !selectName?.start_date ||
              !selectName?.stop_date ||
              !selectName?.flowsheet_group ||
              isFormdateDirty
            : !selectName?.start_date ||
              !selectName?.stop_date ||
              isFormdateDirty
        }
        sx={{
          mr: 2,
          backgroundColor: theme.palette.primary.dark
        }}>
        {t('PRIVATE.COMMON.FILTER', {ns: 'private'})}
      </LoadingButton>
    );
  };

  const renderResetButton = () => {
    return (
      <LoadingButton
        onClick={onReset}
        type="reset"
        variant="outlined"
        sx={{
          mr: 2,
          backgroundColor: theme.palette.primary.light
        }}>
        {t('PRIVATE.COMMON.RESET', {ns: 'private'})}
      </LoadingButton>
    );
  };

  const renderMainFields = (): ReactElement => {
    return (
      <ContainerGridStyle container spacing={2}>
        {Object.entries(sectionUIData?.fields).map(
          (item: any, index: number) => {
            return (
              <Grid item key={index} xs={12} md={3}>
                {item[1].type === FormConstants.FIELD_TYPES.DATE
                  ? renderDateField(item[0], item[1])
                  : item[1].type === FormConstants.FIELD_TYPES.SELECT
                    ? renderSelectFields(item[0], item[1])
                    : ''}
              </Grid>
            );
          }
        )}
        <Grid container sx={{margin: '1rem'}}>
          <Grid item>
            {isFormDirty ? (
              <div style={{color: 'red', marginBottom: '0.5rem'}}>
                {t('PRIVATE.COMMON.ALL_FIELDS_REQUIRED', {ns: 'private'})}
              </div>
            ) : null}
            {isStartDateGreater ? (
              <div style={{color: 'red', marginBottom: '0.5rem'}}>
                Start Date is Greater Than Stop Date
              </div>
            ) : null}
          </Grid>
          <Grid item xs={12} display="flex" sm={6} md={12}>
            {renderSearchButton()} {renderResetButton()}
          </Grid>
        </Grid>
      </ContainerGridStyle>
    );
  };

  const renderDialog = (dialogProps: any): React.ReactElement => {
    return <ActionModalDialog {...dialogProps} />;
  };

  return (
    <>
      {!isLocalSearchActive && (
        <Card sx={{p: 3, boxShadow: 5, borderRadius: '8px'}}>
          <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            {dropdownValues ? (
              <InputFieldGrid>{renderMainFields()}</InputFieldGrid>
            ) : (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                <PulseLoader color={theme.palette.primary.main} />
              </div>
            )}
          </FormProvider>
        </Card>
      )}

      <Card
        sx={{
          mt: 2,
          p: 3,
          boxShadow: 5,
          borderRadius: '8px'
        }}>
        {showError ? (
          <EmptyContent
            sx={{pt: 1}}
            title="The number of selected columns exceeds the maximum allowed limit."
            description={
              'Please reduce the date range to decrease the number of columns.'
            }
            isImage={false}
          />
        ) : isFormDirty ? (
          <NoDataGridComponentDiv>
            {(noDataForFlowsheet || !data || data?.length === 0) &&
              t('PRIVATE.DASHBOARD.VITAL.NO_DATA', {ns: 'private'})}
          </NoDataGridComponentDiv>
        ) : showDatagrid ? (
          <CircularProgressDiv height="0px">
            <PulseLoader size={12} color={theme.palette.primary.main} />
          </CircularProgressDiv>
        ) : mainColumns && mainColumns.length === 0 ? (
          <NoDataGridComponentDiv>
            {(noDataForFlowsheet || !data || data?.length === 0) &&
              t('PRIVATE.DASHBOARD.VITAL.NO_DATA', {ns: 'private'})}
          </NoDataGridComponentDiv>
        ) : (
          renderDatagridComponent()
        )}
      </Card>

      {renderDialog({
        title:
          params?.submodule_name === FormConstants.SCREENS.FLOWSHEETS
            ? `${t('PRIVATE.FLOWSHEET.TITLE', {
                ns: 'private'
              })}`
            : `${t('PRIVATE.VITAL.TITLE', {
                ns: 'private'
              })} `,
        open: openDialog.viewDialog,
        onClose: dialogClose,
        description: dialogInfo?.dialogDescription,
        handleCloseBtnClick: dialogClose,
        flowSheetScreen: true,
        isVitalDataGrid: vitalDataGrid,
        reportsLoader: dialogLoader,
        noLabelText: `${t('PRIVATE.FLOWSHEET.CLOSE', {
          ns: 'private'
        })}`
      })}
    </>
  );
};

export default VitalsComponent;

